exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.4@core-js/library/modules/_object-pie.js
// module id = 20
// module chunks = 0